import React from "react"
import { ChildrenNode, Matcher, MatchResponse, Node } from "interweave"
import i18n from "@/lib/i18n/i18n"

export interface SlickShiftShareRouteAppMatcherProps {
  href: string
}

/**
 * Custom Interweave matcher for SlickShift shared route URLs
 * Replaces SlickShift URLs with a standardized "Open in Slick" text
 */
export class SlickShiftShareRouteAppMatcher extends Matcher<SlickShiftShareRouteAppMatcherProps> {
  /**
   * Match SlickShift URLs that start with https://app.slickshift.ai/shared-route/
   */
  match(string: string): MatchResponse<{ href: string }> | null {
    // Without the optional query string the clickable link would drop the
    // display settings that the raw text still carries.
    const slickShiftPattern =
      /https:\/\/(?:app\.slickshift\.ai|app\.trickswift\.eu)\/shared-route\/[a-zA-Z0-9_-]+(?:\?[a-zA-Z0-9_\-=&%]+)?/i

    const result = string.match(slickShiftPattern)

    if (!result) {
      return null
    }

    return {
      index: result.index!,
      length: result[0].length,
      match: result[0],
      href: result[0],
      valid: true,
    }
  }

  /**
   * Replace the matched URL with a custom anchor element
   */
  replaceWith(
    children: ChildrenNode,
    props: SlickShiftShareRouteAppMatcherProps,
  ): Node {
    return (
      <a
        href={props.href}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-1 text-blue-600 hover:text-blue-800 hover:no-underline"
      >
        🚛 {i18n.t("maps.routeLinks.openInSlick")}
      </a>
    )
  }

  /**
   * Return the HTML tag name for this matcher
   */
  asTag(): string {
    return "a"
  }
}
